import React from "react";
import { Table } from "antd";
import echarts from "echarts";
import DataShop from "../../../data/shop";
import Util from "../../../util/util";
import "./WishList.less";

function vtFormat(data) {
  var series = [];
  var seriesLen = data[0].visited_shops.length;
  for (var j = 0; j < seriesLen; j++) {
    var seriesArr = {
      type: "bar",
      stack: "vt",
      // barMinHeight: 15,
      tooltip: {
        trigger: "item",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: function(params, ticket, callback) {
          var data = params.data;
          return params.name + ":<br>" + data.name + ":" + data.value + "%";
        }
      },
      itemStyle: {
        emphasis: {
          color: "#F7D21C"
        }
      },
      // silent: true,
      data: []
    };
    series.push(seriesArr);
  }
  var outLen = data.length;
  for (var i = 0; i < outLen; i++) {
    var visited_shops = data[i].visited_shops;
    var innerLen = visited_shops.length;
    for (var n = 0; n < innerLen; n++) {
      var el = {
        value: visited_shops[n].rank,
        name: visited_shops[n].shop_name,
        label: {
          normal: {
            show: true,
            fontSize: 10,
            fontWeight: "lighter",
            fontFamily: "Microsoft YaHei",
            formatter: function(params, ticket, callback) {
              var data = params.data;
              return data.name;
            }
          }
        }
      };
      series[n].data.push(el);
    }
  }
  return series;
}

class WishList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // pn: 1,
      // ps: 15,
      filter: 3,
      pagination: { pageSize: Util.isMobile ? 10 : 15 }
    };
    this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    this.getData(1);
  }

  componentWillUnmount() {
    Util.destroyCharts(this.chart);
  }

  /**
   * 获取表头设置
   * @param list
   * @returns {[null]}
   */
  getColumns(list) {
    let cols = [
      {
        title: "Mac",
        dataIndex: "mac",
        width: 120
      }
    ];
    if (list && list.length) {
      let shops = list[0]["visited_shops"] || [];
      shops.forEach((shop, i) => {
        let k = "shop_" + i;
        cols.push({
          title: "品牌" + (i + 1),
          width: 100,
          // dataIndex: 'shop_' + i,
          render: record => {
            let s = record[k] || {};
            return (
              <div className="shop-wrap">
                <p className="name">{s.name}</p>
                <p className="rank">{s.rank}</p>
              </div>
            );
          }
        });
      });
    }
    return cols;
  }

  /**
   * 数据转化成table行
   * @param list
   */
  formatDatas(list) {
    let data = [];
    list.forEach((item, i) => {
      let d1 = {
        mac: item.mac
      };
      item.visited_shops.forEach((shop, j) => {
        let k = "shop_" + j;
        d1[k] = { name: shop.shop_name, rank: shop.rank + "%" };
      });
      data.push(d1);
    });
    return data;
  }

  getData(pn) {
    let { id, date } = this.props;
    let { filter, pagination } = this.state;
    this.setState({ loading: true });
    DataShop.getPurchaseIntention(
      id,
      date,
      pn - 1,
      pagination.pageSize,
      filter
    ).then(res => {
      let data = res.data;
      if (!data || !data.intentions) {
        this.setState({ loading: false });
        return;
      }
      let list = data.intentions.sort((a, b) => {
        return b.visited_shops.length - a.visited_shops.length;
      });
      let cols = this.getColumns(list);
      let formatList = this.formatDatas(list);
      pagination.current = pn;
      pagination.total = data.total_record;
      this.setState({
        pagination: pagination,
        list: formatList,
        cols: cols,
        loading: false
      });
      // this.renderChart (data.intentions)
    });
  }

  renderChart(data) {
    let like = data;
    let legendData = ["无数据"];
    let seriesData = [];
    if (like && like.length) {
      like.sort((a, b) => {
        return b.visited_shops.length - a.visited_shops.length;
      });
      seriesData = vtFormat(like);
      legendData = like.map(item => {
        return item.mac;
      });
    } else {
      seriesData = [
        {
          type: "bar",
          stack: "vt",
          tooltip: {
            trigger: "item",
            formatter: function(params, ticket, callback) {
              let data = params.data;
              return params.name + ":<br>" + data.name + ":" + data.value + "%";
            }
          },
          data: [{ name: "无数据", value: 0 }]
        }
      ];
    }
    let option = {
      color: [
        "#1E3144",
        "#2D4356",
        "#395366",
        "#3A5D6B",
        "#45696E",
        "#4F8887",
        "#4F908E",
        "#549E97",
        "#5AAA9D",
        "#5FB6A4",
        "#65C0A7",
        "#66D1AE",
        "#7FE5C0",
        "#9FF4D3",
        "#C0F9E2"
      ],
      tooltip: {
        trigger: "item",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        top: 20,
        left: "1%",
        right: "3%",
        bottom: 40,
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: legendData
        }
      ],
      yAxis: [
        {
          type: "value",
          show: false
        }
      ],
      dataZoom: [
        {
          show: true
        },
        {
          type: "inside"
        }
      ],
      series: seriesData
    };
    let chart = this.chart;
    if (chart) {
      Util.destroyCharts(this.chart);
    }
    chart = this.chart = echarts.init(document.getElementById("chartWish"));
    chart.setOption(option);
    Util.registerChartsResize(chart);
  }

  changePage(pagination) {
    this.getData(pagination.current);
  }

  render() {
    let { list, cols, pagination, loading } = this.state;
    return (
      <div className="box-wish-list">
        <h2 className="shop-body-title">
          <i className="icon" />
          <span className="i-title">购买意愿</span>
        </h2>
        <div className="chart-container" id="chartWish">
          <Table
            columns={cols}
            dataSource={list}
            pagination={pagination}
            loading={loading}
            onChange={this.changePage}
            rowKey="mac"
          />
        </div>
      </div>
    );
  }
}

export default WishList;
